import { Provider } from '@angular/core';
import { AssetSidebarAclService } from './asset-sidebar-acl.service';
import { AssetSidebarFormService } from './asset-sidebar-form.service';
import { IS_ASSET_SIDEBAR_ROUTED } from './asset-sidebar.model';
import { AssetSidebarService } from './asset-sidebar.service';

export function provideAssetSidebar(): Provider[] {
  return [
    { provide: IS_ASSET_SIDEBAR_ROUTED, useValue: false },
    AssetSidebarService,
    AssetSidebarFormService,
    AssetSidebarAclService,
  ];
}
